import { render, staticRenderFns } from "./FormIconSelector.vue?vue&type=template&id=10a47650&scoped=true&"
import script from "./FormIconSelector.vue?vue&type=script&lang=js&"
export * from "./FormIconSelector.vue?vue&type=script&lang=js&"
import style0 from "./FormIconSelector.vue?vue&type=style&index=0&id=10a47650&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a47650",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VImg,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle,VSelect})
